import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";
import { AuthPage } from "../../../modules/Auth/pages/AuthPage";

class Logout extends Component {
	componentDidMount() {
		localStorage.removeItem("token");
		localStorage.removeItem("user");
		localStorage.removeItem("userNo");
		localStorage.removeItem("userId");
		localStorage.removeItem("userRole");
		localStorage.removeItem("expirationDate");

		sessionStorage.removeItem("token");
		localStorage.removeItem("botAdminId");
		localStorage.removeItem("botAdminNo");

		this.props.logout();
	}
	render() {
		const { hasAuthToken } = this.props;
		// const hasAuthToken = true;
		return hasAuthToken ? (
			<LayoutSplashScreen />
		) : (
			<Redirect to="/auth/login" />
		);
	}
}

export default connect(
	({ auth }) => ({ hasAuthToken: Boolean(localStorage.getItem("user")) }),
	auth.actions
)(Logout);
